import React from 'react';
import Logo from '../components/Logo/Logo';
import StaticControls from '../components/Controls/StaticControls';

const Home = () => {
  return (
    <div className="page-content">
      <Logo />
      <StaticControls />
    </div>
  );
};

export default Home;